<template>
  <!-- 底部弹出面板 -->
  <div>
    <!-- 蒙层 -->
    <transition name="fade">
      <div class="mask" v-if="visible" @click="handleClose"></div>
    </transition>

    <transition name="slide-up">
      <div class="select-bi-table" v-if="visible">
        <!-- 头部 -->
        <div class="header">
          <span class="header-title">选择您需要分析的报表：</span>
          <div class="header-actions">
            <span class="cancel-btn" @click="handleClose">取消</span>
            <span class="confirm-btn" @click="handleConfirm">确认</span>
          </div>
        </div>

        <!-- 级联选择区域 -->
        <div class="cascader-panel">
          <!-- 第一列 -->
          <div class="cascader-column">
            <div
              v-for="(item, index) in options"
              :key="index"
              class="cascader-item"
            >
              <el-checkbox
                v-model="item.checked"
                :indeterminate="item.indeterminate"
                @click.native.stop
                @change="(val) => handleCheck(item, 1, index)"
              >
              </el-checkbox>
              <div class="cascader-item__wrap" @click="selectFirst(item, index)">
                <span class="item-label">{{ item.name }}</span>
                <i
                  v-if="item.children && item.children.length"
                  class="el-icon-arrow-right item-arrow"
                ></i>
              </div>
            </div>
          </div>

          <!-- 第二列 -->
          <div class="cascader-column">
            <div
              v-for="(item, index) in secondOptions"
              :key="index"
              class="cascader-item"
            >
              <el-checkbox
                v-model="item.checked"
                :indeterminate="item.indeterminate"
                @click.native.stop
                @change="(val) => handleCheck(item, 2, index)"
              >
              </el-checkbox>
              <div class="cascader-item__wrap" @click="selectSecond(item, index)">
                <span class="item-label">{{ item.name }}</span>
                <i
                  v-if="item.children && item.children.length"
                  class="el-icon-arrow-right item-arrow"
                ></i>
              </div>
            </div>
          </div>

          <!-- 第三列 -->
          <div class="cascader-column">
            <div
              v-for="(item, index) in thirdOptions"
              :key="index"
              class="cascader-item"
            >
              <el-checkbox
                v-model="item.checked"
                :indeterminate="item.indeterminate"
                @click.native.stop
                @change="(val) => handleCheck(item, 3, index)"
                ><span class="item-label">{{ item.name }}</span></el-checkbox
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getSelectData, getSelectDataJson } from "@/api/ai/newAi.js";
export default {
  name: "SelectBiTable",
  props: {
    // 是否显示弹窗
    value: {
      type: Boolean,
      default: false,
    },
    msgId: {
      type: String,
      default: ""
    },
    conversationId: {
      type: String,
      default: "",
    },
    hasReChoose: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      options: [],
      activeFirst: -1,
      activeSecond: -1,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    // 第二列选项
    secondOptions() {
      if (this.activeFirst === -1) return [];
      const first = this.options[this.activeFirst];
      return first && first.children ? first.children : [];
    },
    // 第三列选项
    thirdOptions() {
      if (this.activeSecond === -1) return [];
      const second = this.secondOptions[this.activeSecond];
      return second && second.children ? second.children : [];
    },
  },
  created() {
    let fn = getSelectData;
    let id = this.msgId;
    if (this.hasReChoose) {
      fn = getSelectDataJson;
      id = this.conversationId;
    }
    fn(id).then((res) => {
      if (res.data) {
        let data;
        if (this.hasReChoose) {
          data = JSON.parse(res.data.selectItemsDataJson);
        } else {
          data = JSON.parse(res.data);
        }
        // 转换数据结构：select -> checked，初始化 indeterminate
        this.options = this.transformData(data);
      }
    });
  },
  methods: {
    // 转换数据结构
    transformData(items) {
      return items.map((item) => {
        const newItem = {
          ...item,
          checked: item.select || false,
          indeterminate: false,
        };
        if (item.children && item.children.length) {
          newItem.children = this.transformData(item.children);
          // 更新父级状态
          this.updateParentCheck(newItem);
        }
        return newItem;
      });
    },
    // 深拷贝
    deepClone(data) {
      return JSON.parse(JSON.stringify(data));
    },
    // 选择第一列
    selectFirst(item, index) {
      this.activeFirst = index;
      this.activeSecond = -1;
    },
    // 选择第二列
    selectSecond(item, index) {
      this.activeSecond = index;
    },
    // 处理勾选
    handleCheck(item, level, index) {
      if (item.indeterminate){
        item.indeterminate = false;
      }
      // 如果有子项，同时勾选/取消勾选所有子项
      if (item.children && item.children.length) {
        this.toggleChildren(item.children, item.checked);
      }

      // 更新父级状态
      if (level === 2) {
        this.updateParentCheck(this.options[this.activeFirst]);
      } else if (level === 3) {
        const secondItem = this.secondOptions[this.activeSecond];
        this.updateParentCheck(secondItem);
        this.updateParentCheck(this.options[this.activeFirst]);
      }
    },
    // 递归切换子项选中状态
    toggleChildren(children, checked) {
      children.forEach((child) => {
        child.checked = checked;
        child.select = checked;
        if (child.children && child.children.length) {
          this.toggleChildren(child.children, checked);
        }
      });
    },
    // 更新父级选中状态
    updateParentCheck(parent) {
      if (!parent.children || !parent.children.length) return;

      const allChecked = parent.children.every((child) => child.checked);
      const someChecked = parent.children.some((child) => child.checked);
      const indeterminated = parent.children.some(
        (child) => child.indeterminate
      );
      const indeterminate = indeterminated || (someChecked && !allChecked);
      this.$set(parent, "checked", allChecked);
      this.$set(parent, "indeterminate", indeterminate);
    },
    // 获取所有选中的值
    getCheckedValues() {
      const result = [];
      const traverse = (items) => {
        items.forEach((item) => {
          // menuType为"C"表示内容项（叶子节点），且已选中
          if (item.checked && item.menuType === "C") {
            result.push({
              name: item.name,
              enumName: item.enumName
            });
          }
          if (item.children && item.children.length) {
            traverse(item.children);
          }
        });
      };
      traverse(this.options);
      return result;
    },
    // 关闭弹窗
    handleClose() {
      this.visible = false;
      this.$emit("close");
    },
    // 确认选择
    handleConfirm() {
      const values = this.getCheckedValues();
      if (!values.length) {
        this.$message.warning("请选择报表!");
        return;
      }
      this.$emit("confirm", values);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// 蒙层
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 2000;
}

// 底部面板
.select-bi-table {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 20px 20px 0 0;
  z-index: 2001;
  height: 320px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #eeeffe 0%, #f8fbfe 50%, #ffffff 100%);
  border-radius: 20px;
  padding: 20px;
}

// 头部
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-shrink: 0;
  &-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  &-actions {
    display: flex;
    gap: 16px;
  }
}

.cancel-btn {
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.confirm-btn {
  font-size: 14px;
  color: #3159ff;
  cursor: pointer;
  font-weight: 500;
}

// 级联面板
.cascader-panel {
  display: flex;
  flex: 1;
  overflow: hidden;
  border: 1px solid #e5e9f2;
  border-radius: 8px;
}

.cascader-column {
  flex: 1;
  overflow-y: auto;
  border-right: 1px solid #e5e9f2;
  padding: 4px;
  background-color: #fff;

  &:last-child {
    border-right: none;
  }
}

.cascader-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
  padding: 6px 12px;
  margin-bottom: 4px;
  &:last-child {
    margin-bottom: 0px;
  }
  &__wrap {
    flex: 1;
    display: flex;
    align-items: center;
  }

  &:hover {
    background: rgba(49, 89, 255, 0.06);
    border-radius: 4px;
  }

  .item-label {
    flex: 1;
    margin-left: 8px;
    font-size: 14px;
    color: #333;
  }

  .item-arrow {
    color: #999;
    font-size: 14px;
  }

  /deep/ .el-checkbox {
    display: flex;
    align-items: center;
  }

  /deep/ .el-checkbox__label {
    line-height: 20px;
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 0px;
  }
}

// 过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
}

// 滚动条样式
.cascader-column::-webkit-scrollbar {
  width: 4px;
}

.cascader-column::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.cascader-column::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}
</style>
